module.exports = __webpack_public_path__ + "static/media/secure-key.32e776bf.png";